/**
 * Coure.RateBillingManagement.API 
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type EntityStatus = 1 | 2;

export const EntityStatus = {
    NUMBER_1: 1 as EntityStatus,
    NUMBER_2: 2 as EntityStatus
};